'use strict';

const consoleHandler = require('./consoleHandler');
const stackDriverClient = require('./stackDriverClient');

function areOptionsValid(options) {
  const requiredOpts = ['logName', 'apiKey', 'logCollectorURL'];
  for (const opt of requiredOpts) {
    if (!options[opt]) {
      console.log('Failed to boot stack driver logging client, the following options are required', requiredOpts);
      return false
    }
  }
  return true;
}

module.exports = (options) => {
  options = options || {};
  const isClientAbleToOperate = areOptionsValid(options);
  const isLoggerDisabled = options.disabled || false;
  if(!isClientAbleToOperate) {
    console.warn(
      'Stackdriver logger is not properly configured, the following options are mandatory',
      ['logName', 'apiKey', 'logCollectorURL']
    );
  }

  if (isLoggerDisabled) {
    console.warn('Stackdriver logger is disabled');
  }

  const sdClient = stackDriverClient(options);
  const loggingClient = {
    log: function (severity, args) {
      if (!isClientAbleToOperate || isLoggerDisabled) {
        return;
      }
      sdClient.pushLog(severity, args).catch(err => {
        console.internal('Failed to push log for stackdriver', err);
      });
    },
    setLogLabel: function (key, value) {
      sdClient.setLogLabel(key, value);
    },
    setLogLabels: function (keyValueLabels) {
      for (const [key, value] of Object.entries(keyValueLabels)) {
        sdClient.setLogLabel(key, value)
      }
    },
    removeLogLabel: function (key) {
      sdClient.removeLogLabel(key);
    },
    options: options
  }

  try {
    window.sdLogger = loggingClient;
  } catch (e) {
  }

  if (isClientAbleToOperate && !isLoggerDisabled) {
    consoleHandler(loggingClient);
  }

  return loggingClient;
};
